/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type AppGitUpdateInput = {
  /**
   * The GitHub repository to connect, as "owner/repo". Omit to change only the
   *
   * @remarks
   * tracked branch of the already-connected repository. The workspace must have
   * the Teral GitHub App installed with access to it.
   */
  repository?: string | undefined;
  /**
   * The branch this app's deployments track. Omit to adopt the repository's
   *
   * @remarks
   * GitHub default branch on a new connection, keep the current branch when
   * replacing an already-connected repository, or set it alone to retarget the
   * branch of the connected repository.
   */
  defaultBranch?: string | undefined;
};

/** @internal */
export type AppGitUpdateInput$Outbound = {
  repository?: string | undefined;
  defaultBranch?: string | undefined;
};

/** @internal */
export const AppGitUpdateInput$outboundSchema: z.ZodType<
  AppGitUpdateInput$Outbound,
  z.ZodTypeDef,
  AppGitUpdateInput
> = z.object({
  repository: z.string().optional(),
  defaultBranch: z.string().optional(),
});

export function appGitUpdateInputToJSON(
  appGitUpdateInput: AppGitUpdateInput,
): string {
  return JSON.stringify(
    AppGitUpdateInput$outboundSchema.parse(appGitUpdateInput),
  );
}
